import { styled } from '@abyss/web/tools/styled';
import { Flex } from '@abyss/web/ui/Flex';
import { Layout } from '@abyss/web/ui/Layout';
import { Pagination } from '@abyss/web/ui/Pagination';

export const SidePaneCloseButtonWrap = styled('div', {
  position: 'absolute',
  '@screen < $sm': {
    display: 'none',
  },
});

export const SidePaneCloseButtonStyle = styled(Flex, {
  top: '$lg',
  position: 'absolute',
  cursor: 'pointer',
  zIndex: 1,
  height: '42px',
  width: '26.17px',
  backgroundColor: 'white',
  boxShadow: '0 2px 6px rgba(25, 25, 26, 0.16)',
  border: '1px solid $gray3',
  borderRadius: '0 4px 4px 0',
});

export const PopupStyle = styled({
  background: 'transparent !important',
});

export const MapDataPagination = styled(Pagination, {
  'abyss-pagination-root': {
    margin: '10px auto 20px',
    '@screen < $md': {
      visibility: 'hidden',
      display: 'inline-block',
    },
  },
});

export const ListWrapColumn = styled('div', {
  dynamic: ({
    cssProps: {
      isOpenCompareShare,
      enableMapViewEnhancements,
      enableMapViewHideOption,
      expandedProviderListView,
    },
  }) => ({
    height: enableMapViewEnhancements
      ? isOpenCompareShare
        ? null
        : null
      : isOpenCompareShare
      ? 'calc(100vh - 220px)'
      : 'calc(100vh - 120px)',
    maxWidth: enableMapViewHideOption && expandedProviderListView && '1200px',
    width: enableMapViewHideOption && '100%',
  }),
  display: 'inline-block',
  boxShadow: '#xs 0px $xs rgba(0, 0, 0, 0.2)',
  backgroundColor: '$primary2',
  zIndex: 2,
  '@screen < $md': {
    position: 'fixed',
    width: '100%',
    background: 'transparent',
    bottom: '$lg',
    height: 'auto !important',
    '.side-btn': { display: 'none' },
  },
  flexShrink: 1,
});

export const ListWrap = styled('div', {
  dynamic: ({
    cssProps: { expandedProviderListView, enableMapViewHideOption },
  }) => ({
    marginBottom: '16px',
    width: expandedProviderListView ? '100%' : '432',
    maxWidth: expandedProviderListView && '1200px',
    overflowY: expandedProviderListView && 'visible',
    paddingRight:
      !expandedProviderListView && enableMapViewHideOption ? '40px' : '$md',
  }),
  display: 'flex',
  paddingLeft: '5px',
  height: '100%',
  gap: '$md',
  flexWrap: 'nowrap',
  flexDirection: 'column',
  '@screen >= $sm': {
    overflowY: 'auto',
  },
  '.abyss-pagination-results-text': {
    marginLeft: 0,
    '@screen < $md': {
      display: 'none',
    },
  },
  '@screen < $sm': {
    width: '100%',
    background: 'transparent',
    display: 'flex',
    paddingLeft: '5px',
    paddingTop: '5px',
    paddingRight: '$md',
    height: '100%',
    gap: '$md',
    flexWrap: 'nowrap',
    flexDirection: 'column',
    '@screen >= $sm': {
      overflowY: 'auto',
    },
    '.abyss-pagination-results-text': {
      marginLeft: 0,
      '@screen < $md': {
        display: 'none',
      },
    },
    '@screen < $sm': {
      width: '100%',
      background: 'transparent',
      display: 'flex',
      gap: '$md',
      padding: '0px',
      flexDirection: 'column',
      '.abyss-card-root': {
        display: 'inline-flex',
        width: '320px',
      },
    },
  },
});

export const MapViewWrap = styled('div', {
  dynamic: ({
    cssProps: {
      urlCheck,
      enableMapViewEnhancements,
      choosePCP,
      enableMapFilterSortCTA,
      enableMapViewHideOption,
      expandedProviderListView,
    },
  }) => ({
    position: enableMapViewEnhancements && 'sticky',
    top:
      enableMapViewEnhancements &&
      (enableMapFilterSortCTA
        ? urlCheck
          ? '163px'
          : '123px'
        : choosePCP
        ? urlCheck
          ? '229px'
          : '189px'
        : urlCheck
        ? '180px'
        : '140px'),
    bottom: enableMapViewEnhancements && '0',
    height: enableMapViewEnhancements ? '100%' : 'calc(100vh - 187px)',
    width: expandedProviderListView
      ? '100%'
      : enableMapViewHideOption
      ? 'calc(100% - 510px)'
      : 'calc(100% - 450px)',
    '@media (max-width: 975px) and (orientation: landscape)': {
      top: 0,
    },
  }),
  '@screen < $md': {
    width: '100% !important',
  },
});

export const PaginationControl = styled('div', {
  display: 'flex',
  '.abyss-pagination-page-size-root': {
    marginRight: '10px',
  },
  '@screen < $md': {
    display: 'none',
  },
});

export const LoadingContainer = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: '10px',
});

export const ZoomButton = styled(Flex, {
  background: '$primary2',
  width: '48px',
  height: '88px',
  borderRadius: '100px',
  gap: '$md',
  padding: '3px',
});

export const PagingationWrapStyled = styled('div', {
  dynamic: ({ cssProps: { isGroupedLocationDrawer } }) => ({
    display: isGroupedLocationDrawer ? '' : 'flex',
    gap: '16px',
    position: 'sticky',
    paddingBottom: '16px',
    '@screen < $md': {
      paddingBottom: !isGroupedLocationDrawer ? '0px' : '16px',
    },
  }),
});

export const EAPStyle = styled('div', {
  paddingBottom: '32px',
  '@media (max-width: 1268px)': {
    width: '98%',
  },
  '@screen < $xl': {
    width: '94%',
  },
});

export const MapviewWrapper = styled(Flex, {
  dynamic: ({
    cssProps: {
      enableMapViewEnhancements,
      isOpenCompareShare,
      openMapview,
      navigateToDirections,
      enableMapViewHideOption,
      expandedProviderListView,
    },
  }) => ({
    position: 'relative',
    height: enableMapViewEnhancements
      ? isOpenCompareShare
        ? null
        : null
      : isOpenCompareShare
      ? 'calc(100vh - 5px)'
      : 'calc(100vh - 20px)',
    display:
      enableMapViewHideOption && expandedProviderListView
        ? 'block'
        : openMapview || navigateToDirections
        ? 'flex'
        : 'none',
  }),
  width: '100%',
  flexWrap: 'nowrap !important',
  '@screen < $sm': { height: '100vh' },
  '.abyss-layout-stack': {
    alignItems: 'flex-start',
  },
  '.abyss-psx-parcel-c-fMjHkp-idMGLLx-css': {
    marginTop: '0px',
    marginBottom: '0px',
  },
});

export const EnhanceStackWrapper = styled(Layout.Stack, {
  dynamic: ({
    cssProps: {
      urlCheck,
      enableMapViewEnhancements,
      choosePCP,
      enableMapFilterSortCTA,
      stickyHeaderDisabled,
      enableMapViewHideOption,
      expandedProviderListView,
      enableListViewHeaderSticky,
    },
  }) => ({
    maxWidth:
      enableMapViewEnhancements && enableMapViewHideOption
        ? expandedProviderListView
          ? 'auto'
          : '510px'
        : urlCheck
        ? '450px'
        : '480px',
    width: enableMapViewEnhancements
      ? enableMapViewHideOption && expandedProviderListView
        ? '100%'
        : 'auto'
      : 'auto',
    '.abyss-psx-parcel-c-PJLV-ihOPXEj-css': {
      '&:first-child': {
        marginTop: '0px',
        marginBottom: '0px',
        position: stickyHeaderDisabled
          ? 'static'
          : enableMapViewEnhancements
          ? enableListViewHeaderSticky
            ? 'sticky'
            : 'static'
          : 'static',
        top:
          enableMapViewHideOption && expandedProviderListView
            ? urlCheck
              ? '40px'
              : '0px'
            : enableMapViewEnhancements && enableMapFilterSortCTA
            ? urlCheck
              ? '163px'
              : '123px'
            : choosePCP
            ? urlCheck
              ? '229px'
              : '189px'
            : urlCheck
            ? '180px'
            : '140px',
        zIndex: enableMapViewEnhancements && '2',
        backgroundColor: enableMapViewEnhancements && 'white',
        maxWidth:
          enableMapViewHideOption && expandedProviderListView && '1200px',
        width: enableMapViewHideOption && expandedProviderListView && '100%',
        right: 'auto',
      },
      '&:last-child': {
        width: enableMapViewHideOption && '100%',
        marginTop: '0',
        marginBottom: '0',
      },
    },
  }),
});

export const EnhancePaginationStyles = (expandedProviderListView: boolean) => ({
  position: expandedProviderListView ? '' : 'sticky',
  bottom: '0px',
  zIndex: '1',
  backgroundColor: 'white',
  justifyContent: expandedProviderListView ? 'center' : '',
  ['@media (max-width: 975px) and (orientation: landscape)']: {
    position: 'static',
  },
});

export const MapStyleWrap = styled('div', {
  position: 'relative',
  top: '0',
  '@screen < $sm': {
    position: 'sticky',
    top: '60px',
  },
});

export const DataCardCheckBoxStyle = {
  'abyss-checkbox-root': {
    '& > div': { alignItems: 'center' },
    paddingLeft: '$xs',
    width: '100%',
    '.abyss-checkbox-flex-container': {
      '& > .abyss-layout-group': {
        flexGrow: 1,
        '& > div': {
          flexGrow: 1,
        },
      },
    },
  },
  'abyss-checkbox-label': {
    marginTop: '0px',
    padding: 0,
    marginLeft: '19px',
    width: '100%',
  },
};

export const AddToCompareLabelStyle = (
  enableCompareButtonRelocation: boolean
) => ({
  position: 'absolute' as const,
  top: enableCompareButtonRelocation ? '-22px' : '-30px',
  left: '28px',
});
export const dataCardCssWidth = (
  expandedProviderListView: boolean,
  enableMapViewHideOption: boolean
) => (!expandedProviderListView && enableMapViewHideOption ? '462px' : '408px');
